<template>
  <div class="chat-toggle">
    <button class="btn btn-secondary btn-option" @click="openActions">
      <i class="fa fa-ellipsis-v text-secondary"></i>
    </button>
    <div id="chatActions" class="chat-actions" :class="{show}" tabindex="0"
         @blur="show = false" @click="show = false">
      <ul class="ul">
        <li class="li">
          <a href="javascript:" class="text-decoration-none text-dark" @click="$emit('chatEvent', 3)">Dados do contato</a>
        </li>
        <li class="li">
          <a href="javascript:" class="text-decoration-none text-dark" @click="transferChat()">Transferir atendimento</a>
        </li>
        <li class="li" v-if="dados.available">
          <a href="javascript:" class="text-decoration-none text-dark" @click="closeChat()">Encerrar atendimento</a>
        </li>
        <li class="li">
          <a href="javascript:" class="text-decoration-none text-dark" @click="clearChat()">Limpar conversa</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatToggle",
  props: ['dados'],
  data() {
    return {
      show: false,
    }
  },

  methods: {
    closeChat() {
      this.$swal({
        text: "Deseja encerrar este atendimento?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.$emit('chatEvent', 1);
        }
      }));
    },

    openActions() {
      this.show = !this.show;
      this.$nextTick(() => {
        if (this.show) {
          this.$helpers.focusElement('chatActions')
        }
      })
    },

    clearChat() {
      this.$swal({
        text: "Deseja realmente limpar todo histórico desta conversa?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.$emit('chatEvent', 2);
        }
      }));
    },

    transferChat() {
      this.$emit('chatEvent', 4);
    }
  },
}
</script>

<style scoped>
.chat-toggle {
  position: relative;
}

.chat-actions {
  position: absolute;
  right: 4px;
  top: 42px;
  background-color: #ffffff;
  width: 220px;
  z-index: 9;
  padding: 9px 0;
  border-radius: 3px;
  box-shadow: 0 2px 5px 0 rgba(11,20,26,.26), 0 2px 10px 0 rgba(11,20,.26,.16);
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s, opacity 0s linear;
}

.chat-actions.show {
  visibility: visible;
  opacity: 1;
}

.ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.li {
  font-size: .86em;
  font-weight: 400;
}

.li a {
  display: block;
  padding: 10px 20px;
}

.li a:hover {
  background-color: var(--light);
}
</style>